export const DAYS_AMOUNT_TO_REORGANISE = 17
export const STUDY_DAYS_FOR_CALENDAR = 11
export const DAYS_AMOUNT_FOR_REMIBDER = 5